import { Aspect } from '@teambit/harmony';

export const WorkspaceAspect = Aspect.create({
  id: 'teambit.workspace/workspace',
  dependencies: [],
  defaultConfig: {},
});

export default WorkspaceAspect;
